import DropdownMenu from '../util/dropdownMenu'
import AOS from 'aos';
import TestimonialCarousel from "../util/testimonialCarousel";
import GalleryCarousel from "../util/galleryCarousel";
import PricingAccordion from "../util/pricingAccordion";

export default {
    init() {
        // JavaScript to be fired on all pages
    },
    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired

        AOS.init();

        const dropDownMenu = new DropdownMenu();
        const testimonialCarousel = new TestimonialCarousel();
        const galleryCarousel = new GalleryCarousel();
        const pricingAccordion = new PricingAccordion();
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js